export default "__VITE_ASSET__BEj51hoF__"